export default "__VITE_ASSET__a9482bf5__"